/**
 * Sorts an array of objects by a given key and direction.
 * @param {Array} array - The array to sort.
 * @param {string} key - The key to sort by.
 * @param {string} direction - 'ascending' or 'descending'.
 * @returns {Array} - The sorted array.
 */
export function sortArrayByKey(array, key, direction = 'descending') {
  if (!key) return array;

  const sorted = [...array].sort((a, b) => {
    let aValue = a[key];
    let bValue = b[key];

    if (key === 'posted_on') {
      aValue = new Date(aValue);
      bValue = new Date(bValue);
    }

    if (aValue < bValue) {
      return direction === 'descending' ? -1 : 1;
    }
    if (aValue > bValue) {
      return direction === 'descending' ? 1 : -1;
    }
    return 0;
  });

  return sorted;
}
